import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux"
import { useLocation } from 'react-router-dom';

import Swal from "sweetalert2";

import { useNavigate } from "react-router-dom";
import Dropdown from 'react-bootstrap/Dropdown';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Button from 'react-bootstrap/Button';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Login from '../Login/index'
import logo from '../../assets/images/logo.png'
import cartIconBag from '../../assets/images/cart-bag-icon.svg'
import product1 from "../../assets/images/product-1.png";
import avtarProfile from "../../assets/images/avtar-profile.png";

import { defaultProduct } from "../../Constant/index";

import { setCart } from "../../Redux/Slice/cartSlice"
import { getCart, deleteCart, addToCart } from '../../Services/Cart'
import { vendor } from "../../Constant"





const Header = () => {
  const dispatch = useDispatch();
  let location = useLocation()

  const { cart } = useSelector((state) => state.cart)
  const tax = useSelector((state) => state.cart.tax)


  const [show, setShow] = useState(false);
  const [carts, setCarts] = useState([]);


  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  /*------------cart-function--------------*/

  const [cartShow, setCartShow] = useState(false);

  const handleCartClose = () => setCartShow(false);
  const handleCartShow = () => setCartShow(true);



  const navigate = useNavigate();
  const [loginShow, setLoginShow] = useState(false);
  const [total, setTotal] = useState(null);
  const [subTotal, setSubTotal] = useState(null);
  const [discount, setDiscount] = useState(null);



  useEffect(() => {
    if (!cart) return
    setCarts(cart)
  }, [cart])

  useEffect(() => {
    if (!localStorage.getItem("ownezzy-user-loggedIn")) return
    getCartData()
  }, [localStorage.getItem("ownezzy-user-loggedIn")])

  useEffect(() => {
    getBill()
  }, [carts])

  let getCartData = async () => {
    const response = await getCart();
    dispatch(setCart(response.data))
  }

  let getBill = () => {
    if (!carts) return
    let total = carts.reduce((n, { cart }) => n + (cart.price * cart.quantity), 0)
    let subTotal = carts.reduce((n, { cart }) => n + (cart.originalPrice * cart.quantity), 0)
    let discount = carts.reduce((n, { cart }) => n + (cart.discount * cart.quantity), 0)
    setTotal(total)
    setSubTotal(subTotal)
    setDiscount(discount)
  }


  const handleIsActiveTab = (route) => {
    navigate(route)
  }

  let deleteCartData = async (id) => {
    Swal.fire({
      title: 'Remove Item',
      text: "Are you sure you want to remove this item ?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#2ba95d',
      confirmButtonText: 'Remove'
    }).then(async (result) => {

      if (result.isConfirmed) {
        let payload = {
          "cartId": id
        }
        let data = await deleteCart(payload)
        getCartData()
        // handleCartClose()

        Swal.fire({
          title: 'Success',
          text: "Your item has been removed .",
          confirmButtonColor: '#2ba95d',

        })

        // Swal.fire(
        //   'Success!',
        //   'Your item has been removed.',
        //   'success'
        // )
      }
    })
  }


  const handleLoginShow = () => setLoginShow(true);
  let logOut = () => {
    localStorage.clear()
    setShow(false)
    navigate('/')
  }
  let userName = 'A'
  let isLoggedIn = localStorage.getItem('ownezzy-user-loggedIn')
  if (isLoggedIn) {
    userName = localStorage.getItem('ownezzy-user-name').charAt(0).toUpperCase()
  }



  let addCartItem = async (val) => {
    let payload = {
      vendor: vendor,
      productId: val._id,
      quantity:   1,
      cart:
      {
        "prices": val.prices,
        "image": val.image,
        "_id": val._id,
        "title": val.title,
        "description": val.description,
        "category": val.category,
        "price": val.prices.price,
        "originalPrice": val.prices.originalPrice,
        "discount": val.prices.discount,
        "quantity":  1,
        "itemTotal": val.prices.price * (val.quantity + 1)

      }
    }

    const response = await addToCart(payload);
    if (response.status == 200) {
      getCartData()
      // Swal.fire({
      //   position: 'top-end',
      //   icon: 'success',
      //   title: 'Item added to cart',
      //   showConfirmButton: false,
      //   timer: 1500,
      //   heigth: '100px'
      // })
    }

  }

  let removeCartItem =  async (val) => {
    if(val.quantity < 2) return
    let payload = {
      vendor: vendor,
      productId: val._id,
      quantity:  - 1,
      cart:
      {
        "prices": val.prices,
        "image": val.image,
        "_id": val._id,
        "title": val.title,
        "description": val.description,
        "category": val.category,
        "price": val.prices.price,
        "originalPrice": val.prices.originalPrice,
        "discount": val.prices.discount,
        "quantity":  - 1,
        "itemTotal": val.prices.price * (val.quantity - 1)

      }
    }

    const response = await addToCart(payload);
    if (response.status == 200) {
      getCartData()
      // Swal.fire({
      //   position: 'top-end',
      //   icon: 'success',
      //   title: 'Item added to cart',
      //   showConfirmButton: false,
      //   timer: 1500,
      //   heigth: '100px'
      // })
    }
  }



  return (
    <>
      <Offcanvas show={show} className="asside-wap-bar">
        <Offcanvas.Header closeButton="12" className="text-end btnclose-menu" onHide={handleClose}>
          <div className="mobile-logo-aside">
            <span className="logo-mobile-web" onClick={() => handleIsActiveTab('/')}><img src={logo} alt="" /></span>
          </div>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          <div className="asside-menubar">
            <ul className="menuitem--aside">
              <li className="menu-item-mv"><a href="" className="linkmenu-web" onClick={() => handleIsActiveTab('/')}><i className="fal fa-home-lg-alt me-2"></i>Home</a></li>
              <li className="menu-item-mv"><a href="" className="linkmenu-web" onClick={() => handleIsActiveTab('/about-us')}><i className="fal fa-users me-2"></i>About Us</a></li>
              <li className="menu-item-mv"><a href="" className="linkmenu-web" onClick={() => handleIsActiveTab('/contact-us')}><i className="fal fa-phone-alt me-2"></i>Contact Us</a></li>
            </ul>
          </div>
          {
            isLoggedIn ?
              <div className="bottom-ftr-logout">
                <button onClick={logOut} type="button" className="btn btn-logout-btn"><i className="far fa-power-off me-2"></i>Logout</button>
              </div>
              :
              <div className="bottom-ftr-logout">
                <button onClick={handleLoginShow} type="button" className="btn btn-logout-btn"><i className="far fa-power-off me-2"></i>Login</button>
              </div>
          }

        </Offcanvas.Body>
      </Offcanvas>
      <div className="header-element">
        <Navbar expand="lg" className="px-lg-">
          <Container fluid>
            <Navbar.Brand className="logo-brand cursor p-0 m-0 order-1"><button type="button" className="btn btnlink-pg p-0" onClick={() => handleIsActiveTab('/')}><img src={logo} alt="" /></button></Navbar.Brand>
            <Button type="button" variant="bg-toggle" className="d-lg-none togglebar-menu order-3" onClick={handleShow}><i className="far fa-bars"></i></Button>
            <div className="search-bar-group-wap order-2">
              <div className="d-flex flex-serach-area">
                <input type="text" className="form-control search-bar" placeholder="Search" />
                <button type="button" className="btn btn-search-top">Search</button>
              </div>
            </div>
            <Navbar.Collapse id="navbarScroll" className="order-4">
              <Nav
                className="ms-auto my-2 my-lg-0 text-center align-items-center"
                style={{ maxHeight: '100px' }}
                navbarScroll
              >
                <ul className="d-flex align-items-center mb-0">
                  <li><Nav.Link className={`item-link-nav ${location.pathname == '/' ? 'active' : ''}`} onClick={() => handleIsActiveTab('/')}>Home</Nav.Link></li>
                  <li><Nav.Link className={`item-link-nav ${location.pathname == '/about-us' ? 'active' : ''}`} onClick={() => handleIsActiveTab('/about-us')}>About Us</Nav.Link></li>
                  <li><Nav.Link className={`item-link-nav ${location.pathname == '/contact-us' ? 'active' : ''}`} onClick={() => handleIsActiveTab('/contact-us')}>Contact Us</Nav.Link></li>
                  {/* <li><Nav.Link className="item-link-nav" href="#action2">Account</Nav.Link></li>*/}
                  {
                    isLoggedIn ? <li>
                      <button className="item-link-nav nav-link" onClick={handleCartShow}>
                        <div className="cart-wigit-icon position-relative d-inline-block" >
                          <img src={cartIconBag} className="" alt="" />
                          <span className="bagetxt-count">{carts && carts.length ? carts.length : 0}</span>
                        </div>
                      </button>
                    </li> : null
                  }

                  {/*<li>
                     <button type="button" className="item-link-nav nav-link">
                      <div className="notify-bell-wigit-icon position-relative d-inline-block" >
                        <i className="fal fa-bell icon-bell-notify"></i>
                        <span className="bagetxt-count">{0}</span>
                      </div>
                    </button> 
                </li>*/}
                  {
                    !isLoggedIn ? <li><Nav.Link className="item-link-nav" onClick={handleLoginShow}>Login</Nav.Link></li>
                      : null
                  }
                  {
                    isLoggedIn ? <li>
                      <Dropdown align="end" className="dropdown-profile-web">
                        <Dropdown.Toggle variant="btn border-0 p-0 ms-2" className="item-link-nav profile-nav-item">
                          <img src={avtarProfile} className="img-avar-pic d-none" alt="" />
                          <span className="avtar-txt-web">{userName}</span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="dropdown-wap-profile p-0 overflow-hidden">
                          <ul className="multi-wigt--dashweb">
                            <li className="item-menu-wigtweb"><button onClick={() => handleIsActiveTab('/profile')}><i className="far fa-user me-2"></i> Profile</button></li>
                            <li onClick={logOut} className="item-menu-wigtweb"><button><i className="far fa-unlock-alt me-2"></i>Logout</button></li>
                          </ul>
                        </Dropdown.Menu>
                      </Dropdown>
                    </li> : null
                  }
                </ul>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>
      <Login loginShow={loginShow} setLoginShow={setLoginShow} />
      {
        isLoggedIn ?
          <div className="footer-bottom-wigit d-lg-none">
            <div className="footer-container-web">
              <ul className="webmult-ftr">
                <li className="menu-ftr-wigt text-start"><button onClick={() => handleIsActiveTab('/')} type="button" className="btn btn-ftr-menu"><i className="far fa-home-lg-alt"></i></button></li>
                <li className="menu-ftr-wigt">
                  <button type="button" className="btn btn-ftr-menu">
                    <div onClick={handleCartShow} className="cart-wigit-icon position-relative d-inline-block">
                      <img src={cartIconBag} className="" alt="" />
                      {/* <span className="bagetxt-count">10</span> */}
                      <span className="bagetxt-count">{carts && carts.length ? carts.length : 0}</span>

                    </div>
                  </button>
                </li>
                <li className="menu-ftr-wigt"><button onClick={() => handleIsActiveTab('/profile')} type="button" className="btn btn-ftr-menu"><i className="far fa-user"></i></button></li>
                {/* <li className="menu-ftr-wigt text-end"><button type="button" className="btn btn-ftr-menu"><i className="far fa-sign-in-alt"></i></button></li> */}
              </ul>
            </div>
          </div>
          :
          null
      }




      <Offcanvas show={cartShow} onHide={handleCartClose} placement="end">
        <Offcanvas.Header bsPrefix="offcanvas-header header-sidecart" closeButton>
          <Offcanvas.Title><i className="fad fa-bags-shopping me-2"></i>Shopping Cart</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="cartbody--elemnt">
          {
            carts && carts.length ?

              <div className="cartpopup--waper">

                <ul className="listcart-multiproduct mb-0">
                  {

                    carts.map((val, i) => {
                      return (
                        <li key={i} className="item-cart-list">
                          <div className="full-listwap--cart">
                            <div className="item-mnt-wapcart">
                              <div className="other-wt--elmnt">
                                <div className="leftImg--flexcart">
                                  <div className="imgthump--elmnt">
                                    <img src={val.cart.image.length ? val.cart.image[0] : defaultProduct} />
                                  </div>
                                </div>
                                <div className="elmnt-product-wigt-mt">
                                  <span className="title-mnt--wt">{val.cart.title}</span>
                                </div>
                              </div>
                            </div>
                            <div className="cart-item-increase">
                              <div className="add-prodt-wigt">
                                <span onClick = {() => removeCartItem(val.cart)} className="txtinput--mt">-</span>
                                <input type="text" value={val.cart.quantity} className="inputcart-add-value form-control" />
                                <span onClick = {() => addCartItem(val.cart)}  className="txtinput--mt">+</span>
                              </div>
                            </div>
                            <div className="wigt-prite-flex">
                              <span className="price-cart-prodt">₹{val.cart.price * val.cart.quantity}</span>
                            </div>
                            <div className="btn-prodt-dlt">
                              <button type="button" onClick={() => deleteCartData(val._id)} className="btn-item-dlt"><i class="far fa-trash-alt"></i></button>
                            </div>
                          </div>
                        </li>
                      )
                    })

                  }


                </ul>
              </div>
              :
              <div className="empty-cart-shoping text-center">
                <div className="cat-icon-epmty">
                  <span><i class="fad fa-shopping-bag"></i></span>
                </div>
                <h3 className="cart-emty-title">Your cart is empty</h3>
                <p className="empty-txt-wgt">No items added in your cart. Please add product to your cart list.</p>
              </div>

          }


        </Offcanvas.Body>
        {
          carts && carts.length ?
            <>
              <div className="footer-button-checkout">
                <div className="total-amnt-wt mt-3">
                  <ul className="price-total-wgt">

                    {/* <li className="lst-total-cart">
                      <div className="leftitem--txt-ttl"><span>Subtotal</span></div>
                      <div className="rightamnt--ttl"><span>₹{carts.length ? subTotal : 0}</span></div>
                    </li> */}

                    {/* <li className="lst-total-cart">
                      <div className="leftitem--txt-ttl"><span>Discount</span></div>
                      <div className="rightamnt--ttl"><span>₹{carts.length ? discount : 0}</span></div>
                    </li> */}

                    {/* 
                    <li className="lst-total-cart">
                      <div className="leftitem--txt-ttl"><span style={{ fontSize: '18px', fontWeight: '500' }}>Total</span></div>
                      <div className="rightamnt--ttl"><span className="sub-totalcart-wgt">
                        ₹{carts.length ?  tax && tax.isEnabled?  (total + parseFloat(tax.percentageAmount/100 * total)).toFixed(2) : total.toFixed(2) : 0}
                        </span></div>
                    </li> */}
                  </ul>
                </div>
                <button type="button" className="btn btn-cart-proceed" onClick={() => handleIsActiveTab('/cart')}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span>
                      Proceed To Checkout
                    </span>
                    <span className="checkout_total_amount">
                      ₹{carts.length ? parseFloat(total) : 0}

                      {/* ₹{carts.length ?  tax && tax.isEnabled?  (total + parseFloat(tax.percentageAmount/100 * total)).toFixed(2) : total.toFixed(2) : 0} */}

                    </span>
                  </div>
                </button>
              </div>
            </>
            :
            null
        }

      </Offcanvas>
    </>
  )
}

export default Header;